module.exports = __webpack_public_path__ + "img/100_dice[9].22d6d653.png";